import React, {useState} from 'react';
import './AdminDeleteUserPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {API_BASE} from '../../../utils/apiConfig';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';

const PAGE_ID = 'AdminDeleteUserPage';

function AdminDeleteUserPage({onBack}) {
  const [userId, setUserId] = useState('');
  const [status, setStatus] = useState(null);

  usePageAnalytics('AdminDeleteUserPage');

  const handleDelete = async () => {
    const trimmedId = userId.trim();
    if (!trimmedId) {
      setStatus({type: 'error', text: 'Введите ID пользователя'});
      return;
    }

    const confirmed = window.confirm(`Удалить пользователя с ID "${trimmedId}"?`);
    if (!confirmed) return;

    try {
      const res = await fetch(`${API_BASE}/admin/users/${trimmedId}`, {
        method: 'DELETE',
        credentials: 'include',
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to delete user');
      }

      setStatus({type: 'success', text: 'Пользователь удалён'});
      setUserId('');
    } catch (e) {
      console.error('Delete user error', e);
      setStatus({type: 'error', text: e.message || 'Не удалось удалить пользователя'});
    }
  };

  return (
    <>
      <h1 className="lobby-page-title">Удалить пользователя</h1>

      <div className="admin-delete-user-form">
        <input
          className="admin-delete-user-input"
          type="text"
          placeholder="ID пользователя"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        />
        <PageButton onClick={handleDelete} pageId={PAGE_ID} buttonId="delete">
          Удалить пользователя
        </PageButton>
        {status && (
          <div className={`admin-delete-user-status admin-delete-user-status_${status.type}`}>
            {status.text}
          </div>
        )}
      </div>

      <div className="main-menu-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default AdminDeleteUserPage;
